import { ApiCart } from '../../../../services/eaptekaApi/methods/cartGet/types';
import { Summary } from '../../../summary/types';
import { serializePrice } from '../serializePrice';
import { serializeWeight } from '../serializeWeight';

export function serializeSummaryFromApi(
  data: ApiCart
): Summary {
  return {
    quantity: data.quantity,
    weight: serializeWeight(data.weight),
    deliveryPrice: serializePrice(data.deliveryPrice),
    sberprime: data.sberprime,
    discount: serializePrice(data.discount),
    productSummary: serializePrice(data.productSummary),
    summary: serializePrice(data.summary),
    bonusProgramEarn: data.bonusProgramEarn,
    notification: data.notification,
    preorderProductsCount: data.preorderProductsCount,
    isCartInstallmentAvailable:
      data.isCartInstallmentAvailable,
    isERecipeAvailable: data.isERecipeAvailable,
    isActiveOnlineRecipeClient:
      data.isActiveOnlineRecipeClient,
    isOnlineRecipeClient: data.isOnlineRecipeClient
  };
}
